exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._2jD5u{margin:0 20px}._9RPw5{margin:64px 40px 96px}._2HzHi{font-weight:700;font-size:36px;line-height:44px;letter-spacing:-.6px;padding-top:6px;padding-bottom:6px}._2HzHi,._19SIQ{color:#484848;margin:0;word-wrap:break-word}._19SIQ{font-weight:200;font-size:16px;line-height:24px;padding-top:0;padding-bottom:0}", ""]);

// exports
exports.locals = {
	"root": "_2jD5u",
	"container": "_9RPw5",
	"headingText": "_2HzHi",
	"subHeading": "_19SIQ"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/components/SearchListing/NoResults/NoResults.css
// module id = 2569
// module chunks = 15